function userLogout(devPort) {
  return fetch(devPort + "delete_cookies", {
    credentials: "include",
    mode: "cors",
  })
    .then((response) => {
      return response.json();
    })
    .catch(() => null)
    .finally(() => {
      // Force a full reload so all in-memory auth state (userName, membership,
      // club selection, etc.) is cleared. Without this, a stale userName can
      // keep firing fetches to auth-only endpoints after the cookie is gone.
      window.location.assign("/account-login");
    });
}

export default userLogout;
